import { createSlice } from '@reduxjs/toolkit';
import {
  ICommunity,
  createCommunity,
  updateCommunity,
  deleteCommunity,
  getCommunities,
  getAllCommunity,
} from './actions';

export interface ICommunityState {
  communities: ICommunity[];
  listCommunity: ICommunity[];
  total: number;
  loading: boolean;
}

const initialState: ICommunityState = {
  communities: [],
  listCommunity: [],
  total: 0,
  loading: true,
};

const CommunitySlider = createSlice({
  name: 'community',
  initialState: initialState,
  reducers: {},
  extraReducers(builder) {
    builder
      // get communities
      .addCase(getCommunities.pending, state => {
        state.loading = true;
      })
      .addCase(getCommunities.fulfilled, (state, action) => {
        state.loading = false;
        state.communities = action.payload.data;
        state.total = action.payload.metadata.total;
      })
      .addCase(getCommunities.rejected, state => {
        state.loading = false;
      })

      // get all community
      .addCase(getAllCommunity.pending, state => {
        state.loading = true;
      })
      .addCase(getAllCommunity.fulfilled, (state, action) => {
        state.loading = false;
        state.listCommunity = action.payload.data;
      })
      .addCase(getAllCommunity.rejected, state => {
        state.loading = false;
      })

      // create community
      .addCase(createCommunity.pending, state => {
        state.loading = true;
      })
      .addCase(createCommunity.fulfilled, state => {
        state.loading = false;
      })
      .addCase(createCommunity.rejected, state => {
        state.loading = false;
      })

      // update community
      .addCase(updateCommunity.pending, state => {
        state.loading = true;
      })
      .addCase(updateCommunity.fulfilled, state => {
        state.loading = false;
      })
      .addCase(updateCommunity.rejected, state => {
        state.loading = false;
      })

      // delete community
      .addCase(deleteCommunity.pending, state => {
        state.loading = true;
      })
      .addCase(deleteCommunity.fulfilled, state => {
        state.loading = false;
      })
      .addCase(deleteCommunity.rejected, state => {
        state.loading = false;
      });
  },
});

export default CommunitySlider.reducer;
